import { connect } from 'react-redux';
import SequenceStep7 from './SequenceStep7';
import { editBatchApplySequence } from '../../store/sequencingWizardSlice';

export default connect(null, { editBatchApplySequence })(SequenceStep7);
